var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.002 8.902a.572.572 0 0 1-.585-.585c0-.16.055-.295.165-.408a.561.561 0 0 1 .42-.168H7.42V3.146c0-.16.057-.295.17-.408a.555.555 0 0 1 .407-.169c.165 0 .303.056.416.169a.555.555 0 0 1 .169.408v5.171a.565.565 0 0 1-.17.416.565.565 0 0 1-.415.169H4.002zM8.004 16c1.093 0 2.122-.21 3.088-.63a8.197 8.197 0 0 0 4.282-4.282A7.697 7.697 0 0 0 16 7.996c0-1.093-.21-2.122-.63-3.088a8.247 8.247 0 0 0-1.733-2.557 8.047 8.047 0 0 0-2.553-1.73A7.75 7.75 0 0 0 7.996 0a7.72 7.72 0 0 0-3.084.622A8.109 8.109 0 0 0 2.359 2.35 8.154 8.154 0 0 0 .626 4.908 7.706 7.706 0 0 0 0 7.996c0 1.098.21 2.129.63 3.092a8.21 8.21 0 0 0 1.733 2.549 8.21 8.21 0 0 0 2.549 1.733c.963.42 1.994.63 3.092.63z",
    fill: "#477AFE",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuration);
export default __webpack_public_path__ + "static/media/icon-duration.3af32b86da40f03ee6d8f635152fcf2e.svg";
export { ForwardRef as ReactComponent };